import React, { Component } from 'react'
import { Dialog } from '@material-ui/core'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import CreateCreditRequest from '../pages/create_credit_request'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import AppBar from '@material-ui/core/AppBar'
import Slide from '@material-ui/core/Slide'
import Comments from './comments'
import CreditRequest from '../pages/CreditRequest'
import axios from 'axios'
import { FB_API_URL } from '../lib/env'
import LinearProgress from '@material-ui/core/LinearProgress'
import { withSnackbar } from 'notistack'
import { flowRight } from 'lodash'
import { MISSED, SUCCESS } from '../constants/stuses'
import ErrorModal from '../asterX-UIkit/modals/ErrorModal'

class SaleAmp extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedTab: 0,
      saleId: null,
      isNewCreditRequestDialogOpen: false,
      selectedCreditRequestForView: null,
      creditRequests: [],
      loading: false,
      error: false
    }
  }

  handleChangeTab(event, selectedTab) {
    this.setState({ selectedTab })
    if (selectedTab === 0) {
      this.getCreditRequestsBySaleGlobalId(this.props.sale.globalId)
    }
  }

  componentDidMount() {
    this.getCreditRequestsBySaleGlobalId(this.props.sale.globalId)
  }

  addNewCreditRequest() {
    axios
      .get(
        FB_API_URL + '/finbroker/credit_request/getUndecidedCreditRequests',
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      )
      .then(response => {
        this.setState({ isNewCreditRequestDialogOpen: true })
      })
      .catch(error => {
        console.log(error.message)
      })
  }

  getCreditRequestsBySaleGlobalId(saleGlobalId) {
    if (!saleGlobalId) {
      saleGlobalId = this.props.sale.client.globalId
    }

    const self = this
    self.setState({ loading: true })
    axios
      .get(
        FB_API_URL + '/finbroker/credit_request/sale_global/' + saleGlobalId,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        }
      )
      .then(function (response) {
        console.log(response.data)
        self.setState({
          creditRequests: response.data,
          loading: false
        })
      })
      .catch(function (error) {
        console.log(error.message)
        self.setState({ loading: false })
      })
  }

  render() {
    let sales = []
    console.log(this.props)

    if (this.props.sale && this.props.sale.endDate !== null) {
      sales.push(this.props.sale)
      sales = sales.concat(this.props.sale.visitSales)
    }

    return (
      <div>
        <div>
          <Tabs
            value={this.state.selectedTab}
            onChange={this.handleChangeTab.bind(this)}
            aria-label="simple tabs example"
          >
            <Tab label="Кредитные заявки" />
            <Tab label="Комментарии" />
          </Tabs>

          <TabPanel value={this.state.selectedTab} index={0}>
            <div>
              <Button
                className="button_green_color button_small"
                style={{ marginRight: '10px' }}
                onClick={this.addNewCreditRequest.bind(this)}
                disabled={
                  !(
                    ![MISSED, SUCCESS].includes(
                      this.props.sale?.saleStatus?.code
                    ) &&
                    this.props.sale?.carfinStatuses?.trackStatus?.code === 20
                  )
                }
              >
                Новая кредитная заявка
              </Button>
              <Button
                className="button_grey_color button_small"
                onClick={this.getCreditRequestsBySaleGlobalId.bind(
                  this,
                  this.props.sale.globalId
                )}
              >
                Обновить
              </Button>
            </div>
            <div>
              {this.state.loading && <LinearProgress />}
              {this.state.creditRequests.map(cr => (
                <CreditRequest
                  onClick={() =>
                    this.setState({ selectedCreditRequestForView: cr })
                  }
                  creditRequest={cr}
                  getCreditRequests={this.getCreditRequestsBySaleGlobalId.bind(
                    this,
                    this.props.sale.globalId
                  )}
                  sale={this.props.sale}
                />
              ))}
            </div>
          </TabPanel>

          <TabPanel value={this.state.selectedTab} index={1}>
            {this.props.sale && (
              <div>
                <Comments
                  comments={
                    this.props.sale.valueComments === null
                      ? []
                      : JSON.parse(this.props.sale.valueComments)
                  }
                  saleId={this.props.sale.id}
                  type="AMP"
                />
              </div>
            )}
          </TabPanel>
        </div>
        {this.state.isNewCreditRequestDialogOpen && (
          <Dialog
            open={this.state.isNewCreditRequestDialogOpen}
            fullScreen
            TransitionComponent={Transition}
          >
            <AppBar
              style={{ position: 'fixed', height: '80px', marginTop: '-10px' }}
            >
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    this.setState({ isNewCreditRequestDialogOpen: false })
                    this.getCreditRequestsBySaleGlobalId(
                      this.props.sale.globalId
                    )
                  }}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6">Кредитная заявка</Typography>
              </Toolbar>
            </AppBar>
            <div style={{ marginTop: '80px' }}>
              <CreateCreditRequest
                closeDialog={() => {
                  this.setState({ isNewCreditRequestDialogOpen: false })
                  this.getCreditRequestsBySaleGlobalId(this.props.sale.globalId)
                }}
                sale={this.props.sale}
              />
            </div>
          </Dialog>
        )}
        <ErrorModal
          e={this.state.error}
          close={() => this.setState({ error: false })}
          snackbar={true}
        />
      </div>
    )
  }
}

export default flowRight(withSnackbar)(SaleAmp)

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />
})
